import React  from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ElementColorType, SizeType } from '../../util/types';
import Button from '../../components/button/Button';

export type StudentButtonTextType = 'see' | 'help';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends HTMLProps {
  /**
   * Button/elements color based on positive/negative semantics.
   */
  color: ElementColorType;
  /**
   * Sets button text.
   */
  text?: StudentButtonTextType | string;
  /**
   * Sets button size.
   */
  size?: SizeType;
  /**
   * Sets if button has been pressed/toggled.
   */
  toggled: boolean;
}

const StudentButton = React.forwardRef<Ref, Props>(({
  color,
  text = 'see',
  size = 'md',
  toggled,
  ...other
}: Props, ref): JSX.Element => {

  const { translate } = useI18n();

  return (
    <div className={'bg-white rounded-full'}>
      <Button
        ref={ref}
        color={color}
        size={size}
        isOutline
        toggle={toggled}
        inlineText
        className='min-w-sm md:min-w-md'
        {...(other as HTMLProps)}
      >
        { [ 'see', 'help' ].includes(text) ? translate(`components.BUTTONS.STUDENTS.${text?.toUpperCase()}`) : text }
      </Button>
    </div>
  );
});

StudentButton.displayName = 'StudentButton';

export default StudentButton;
